import { Component, OnDestroy, OnInit } from '@angular/core';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { RoleService } from 'src/app/services/RoleManagement/role.service';
import { UserSelectionModalComponent } from './user-selection-modal/user-selection-modal.component';
import { Subscription } from 'rxjs';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { LoginService } from 'src/app/services/Login/login.service';

@Component({
  selector: 'app-tour',
  templateUrl: './tour.component.html',
  styleUrls: ['./tour.component.scss'],
})
export class TourComponent implements OnInit, OnDestroy {
  loggedUserId: number;
  loggedUserRoleId: number;
  modalRef?: BsModalRef;
  private routerSubscription?: Subscription;
  selectedUserId: number; //selected user agent/broker from admin/helpdesk modal
  loggedUser: any;

  constructor(
    private roleService: RoleService,
    private modalService: BsModalService,
    private router: Router,
    private loginService: LoginService,
    private route: ActivatedRoute
  ) {
    this.roleService.userDetail$.subscribe((detail) => {
      this.loggedUserId = detail.userId;
      this.loggedUserRoleId = detail.roleId;
    });
  }

  ngOnInit(): void {
    // if (
    //   this.loggedUserRoleId == 1 ||
    //   this.loggedUserRoleId == 2 ||
    //   this.loggedUserRoleId == 3
    // ) {
    //   this.route.queryParams.subscribe((params) => {
    //     const ownerId = Number(params['ownerId']); // Get ownerId from URL
    //     // if no ownerId then open modal
    //     if (!ownerId) {
    //       this.openAdminHelpdeskModal(true);
    //     } else this.handleSelectedId(ownerId);
    //   });
    // }

    // // Close modal when the user navigates to another page
    // this.routerSubscription = this.router.events.subscribe((event) => {
    //   if (event instanceof NavigationStart) {
    //     this.modalRef?.hide();
    //   }
    // });
  }

  handleSelectedId(id: number) {
    this.selectedUserId = id; // Store selected ID in parent
    if (this.loggedUserId > 0) {
      this.loginService
        .GetUserById(id ? id : this.loggedUserId)
        .subscribe((userRes: any) => {
          this.loggedUser = userRes;
        });
    }
  }

  openAdminHelpdeskModal(isInitState: boolean) {
    const modalConfig: ModalOptions = {
      backdrop: isInitState ? 'static' : true,
      keyboard: !isInitState,
      class: 'modal-lg',
    };
    this.modalRef = this.modalService.show(
      UserSelectionModalComponent,
      modalConfig
    );
    if (this.modalRef.content) {
      this.modalRef.content.selectedUserId.subscribe((id: number) => {
        this.handleSelectedId(id);
      });
    }
  }

  ngOnDestroy(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.modalRef?.hide();
      }
    });
    this.routerSubscription?.unsubscribe();
  }
}
